<template>
  <div class="home font-sans w-full h-half-screen" :key="update_list">
    <header-dark class="mt-5" @auth="auth" theme="main-text"></header-dark>
    <section class="pt-8 lg:py-8 xl:py-8 relative text-main-text">

        <authorization-base :is_login="login" @auth="auth" />
      <div class="mx-auto lg:container xl:container pt-8 lg:py-8 xl:py-8  block-width w-full card-container lg:px-0 xl:px-0">
        <div class="flex content-center justify-between">
          <h2 class="text-3xl hidden lg:inline-block">Все игры</h2>
          <filter-games :haveUser="checkForEvents" class="z-10 w-full lg:w-64 xl:w-64"></filter-games>
        </div>
        <div class="flex  flex-col justify-center">
          <div class="flex flex-wrap mt-8 justify-center">
            <payment ref="pay" v-for="event in filteredApplications" :event="event" :events="applications" :key="event.uuid" :user_events="user_events" class="pb-6 card pr-1 lg:pr-6 xl:pr-6"></payment>
            <i v-for="ev in 5" :key="ev" aria-hidden="true"  class="pb-6 card pr-1 lg:pr-6 xl:pr-6"></i>
          </div>
        </div>
      </div>
    </section>
    <section class="pb-8 lg:py-8 xl:py-8 lg:pb-0 xl:pb-0">
      <div class="mx-auto lg:py-8 xl:py-8 flex justify-start overflow-hidden cursor-pointer card-container px-1">
        <router-link
          to="/"
          class="text-lg lg:text-xl xl:text-xl py-3 no-underline text-main-text font-bold rounded-full cursor-pointer"
        >
          <img src="@/assets/vector-left.png" class="h-4 cursor-pointer" />
          Вернуться на главную страницу
        </router-link>
      </div>
    </section>
    <home-footer></home-footer>
  </div>
</template>
<script>
import base from '@/clients/base';
import client from '@/clients/player';
import ShowProfile from '../show-profile.vue';
import parse from 'date-fns/parse';
import SelectCity from '../select-city.vue';
import Payment from './paymentModals/payment.vue';
import HomeHead from '../home-page-layouts/home-head';
import HomeFooter from './home-footer';
import FilterGames from './components/filter-games';
import HeaderDark from './components/header-dark';
import Pagination from '@/helpers/pagination/pagination.vue';
import GamesFilter from '@/helpers/pagination/filter.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import AuthorizationBase from '@/helpers/auth/authorization';
import uuid from 'uuid';

export default {
  name: 'Timetable',
  components: {
    HomeFooter,
    HomeHead,
    Payment,
    SelectCity,
    ShowProfile,
    FilterGames,
    HeaderDark,
    GamesFilter,
    Pagination,
    AuthorizationBase,
  },
  data() {
    return {
      showProfile: false,
      showCity: false,
      client: base,
      login: false,
      data: [],
      update_list: uuid(),
    };
  },

  mounted() {
    if (this.applicationsFetched) {
      if (this.game_id) {
        const ref = this.$refs.pay.find(item => item.event.uuid === this.game_id);
        setTimeout(() => {
          ref.$refs.tryreg.click();
        }, 300);
      }
    }
  },


  computed: {
    ...mapState({
      city_id: state => state.user.cityProps.id,
      user: state => state.auth.user,
      applications: state => state.applications.applications.filter(item => !item.is_created_by_editor),
      game_id: state => state.auth.gameId,
    }),
    ...mapGetters([
      'applicationsFetched',
    ]),
    user_events() {
      return this.user.applications;
    },
    checkForEvents() {
      if (this.user.applications) {
        const appIds = this.user.applications.map(item => item.games_event_day_id);
        return this.applications.filter(item => appIds.indexOf(item.uuid) >= 0);
      }
    },
    currentRoute() {
      return this.$router.currentRoute.query.type;
    },
    filteredApplications() {
      if (!this.currentRoute) {
        return this.applications;
      }
      return this.$store.getters[`${this.currentRoute}Applications`];
    },
  },
  methods: {
    auth() {
      this.login = !this.login;
    },
  },
  watch: {
    city_id(new_city, old_city) {
      this.update_list = uuid();
    },
  },
};
</script>
<style lang="less" scoped>
.hover-up {
  transition: all 0.5s;
  &:hover {
    transform: translateY(-3px);
    @apply shadow-md;
  }
}


i {
  min-width: 360px !important;
  width: 360px !important;
  max-width: 360px;
  flex-basis: 360px;
  box-sizing: content-box;
  height: 10px !important;
}


.flex-2 {
  flex: 757;
}

.flex-3 {
  flex: 1 0 calc(33.333% - 20px);
}

.round {
  border-radius: 20px;
  border-width: 1px;
  width: 1.7em;
  height: 1.7em;
}

.circle {
  width: 45px;
  height: 45px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.11);
  background-color: #bd006c;
  border-radius: 30px;
}

.themes {
  background-color: #f4f4f4;
}

.banner {
  background: url("../../assets/bg_banner.png");
}

.footer {
  height: 214px;
  background-color: #444444;
}

.container-md {
  max-width: 768px;
}

@media (min-width: 1270px) and (max-width: 1910px) and (orientation: landscape) {
  .brand-container {
    max-width: 80%;
  }
  .event-width {
    width: 33.33% !important;
    padding-right: 0.6rem;
    padding-left: 0.6rem;
  }
  .block-width {
    width: 100% !important;
  }
}
@media (min-width: 1911px) and (orientation: landscape) {
  .brand-container {
    max-width: 80%;
  }
  .event-width {
    width: 33.33% !important;
    padding-right: 1.25rem;
    padding-left: 1.25rem;
  }

}


@media only screen and (max-width: 600px) {
  .brand-container {
    max-width: 95%;
  }
}

@media only screen and (min-width: 600px) {
  .brand-container {
    max-width: 95%;
  }
}

@media only screen and (min-width: 768px) {
  .brand-container {
    max-width: 80%;
  }
}

@media only screen and (min-width: 992px) {
  .brand-container {
    max-width: 80%;
  }
}


 .card-container {
            max-width: 95%;
        }


    @media only screen and (min-width: 319px) and (max-width: 330px) {
  .card-container {
    max-width: 290px;
  }
}

@media only screen and (min-width: 400px) and (max-width: 600px) {
  .card-container {
    max-width:380px;
  }
}
@media only screen and (min-width: 330px) and (max-width: 400px) {
  .card-container {
    max-width: 330px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 767px) {
  .card-container {
    max-width: 345px;
  }
}

@media (min-width: 768px) {
  .card-container {
      max-width: 80%;
  }
}


</style>
